import React from 'react';
import styles from './style.module.scss';
import { ButtonPrimary } from '@components';
import { handleCancelSubscription } from '../../pages/GenerationBlock/pages/Billings';

type Props = {
    deleteHandler?: () => void;
    close: (value: boolean) => void;
};

export const ConfirmationPopoverDelete: React.FC<Props> = ({
    deleteHandler,
    close,
}) => {
    return (
        <div className={styles.ConfirmationPopover}>
            <div className={styles.ConfirmationPopover__container}>
                <p className={styles.ConfirmationPopover__title}>
                    Confirm delete
                </p>
                <p>This action will remove it permanently. Are you sure?</p>
                <div className={styles.ConfirmationPopover__buttons}>
                    <ButtonPrimary
                        onClick={() => close(false)}
                        className={styles.ConfirmationPopover__button}
                    >
                        Cancel
                    </ButtonPrimary>
                    <ButtonPrimary
                        onClick={deleteHandler}
                        className={styles.ConfirmationPopover__button}
                        colorScheme="orange"
                    >
                        Delete
                    </ButtonPrimary>
                </div>
            </div>
        </div>
    );
};

export const ConfirmationPopoverUnsubscribe: React.FC<Props> = ({
    close,
}) => {
    return (
        <div className={styles.ConfirmationPopover}>
            <div className={styles.ConfirmationPopover__container}>
                <p className={styles.ConfirmationPopover__title}>
                    Confirm Unsubscribe
                </p>
                <p>This action will cancel your current subscription. Are you sure?</p>
                <div className={styles.ConfirmationPopover__buttons}>
                    <ButtonPrimary
                        onClick={() => close(false)}
                        className={styles.ConfirmationPopover__button}
                    >
                        Stay
                    </ButtonPrimary>
                    <ButtonPrimary
                        onClick={() => close(true)}
                        className={styles.ConfirmationPopover__button}
                        colorScheme="orange"
                    >
                        Unsubscribe
                    </ButtonPrimary>
                </div>
            </div>
        </div>
    );
};